import { IDeductionItemRepository, IAddDeductionItemRepositoryParams, IAddDeductionItemRepositoryResponse } from "@/core/repositories/deduction";

export class AddDeductionItemUseCase {
  constructor(private readonly deductionItemRepository: IDeductionItemRepository) {}

  async execute(params: IAddDeductionItemRepositoryParams): Promise<IAddDeductionItemRepositoryResponse> {
    return this.deductionItemRepository.addDeductionItem(params);
  }
}
